/* es6-set/implement */ function _(require, module, exports) {
    if (!require(380) /* ./is-implemented */()) {
        Object.defineProperty(require(329) /* es5-ext/global */, 'Set', { value: require(383) /* ./polyfill */, configurable: true, enumerable: false,
            writable: true });
    }
}
